import { axiosInstance } from "../helpers/request";
import { AbuseReport, AbuseQuery, AbuseResult } from "../types/abuse";
export async function getAbuseReport(
  report: AbuseReport,
  query: AbuseQuery
): Promise<AbuseResult> {
  const response = await axiosInstance.get<AbuseResult>(
    report === "blocked"
      ? "/admin/abuse/blocked-registrations"
      : "/admin/abuse/incidents",
    {
      params: {
        page: query.page,
        perPage: query.perPage,
        ...(query.filter
          ? { [report === "blocked" ? "reason" : "kind"]: query.filter }
          : {}),
      },
    }
  );
  return response.data;
}
